export type XrbPackagingData = {
  appropriatePackaging?: boolean | null;
  vermiculiteUsed?: boolean | null;
  aeroplastUsed?: boolean | null;
  plasticBagUsed?: boolean | null;
  polyethyleneUsed?: boolean | null;
};

export function isPackagingStepNeeded(xrbData?: XrbPackagingData | null): boolean {
  if (!xrbData) return false;

  return (
    xrbData.appropriatePackaging === false ||
    xrbData.vermiculiteUsed === true ||
    xrbData.aeroplastUsed === true ||
    xrbData.plasticBagUsed === true ||
    xrbData.polyethyleneUsed === true
  );
}
